import { AesUtil } from "../../../JS/AesUtil";
import { CMSPath, CMSPath_Master, globalIV, globalSalt } from "../../../config/constant";
import { getTheKnowLoginUrl, getVredStayData } from "../../../action/the_know";
import { isUserLoggedin } from "../hotelSelector/hotelSelector";
import clientConfigApi from "../../../../src/config/config"
import Axios from "axios";
import { inAppBrowser } from "../../JS/inAppBrowser";

export const mapPmsPropertyCodeToHotelData =  (pms_property_name,location_data)=>{
    console.log("inside mapPmsPropertyCodeToHotelData", pms_property_name, location_data )
    const hotelData= location_data;
     for( let regionData of hotelData ){
        for( let hotel of regionData.hotelList){
            if( hotel && hotel.hotelMetaData && ( hotel.hotelMetaData.pmsPropertyCode == pms_property_name)){
                return hotel;
            }
        }
    }

    return {};
}

export const isPossiblePreCheckinOpened=(date)=>{
    if( (new Date(date)).setHours(0,0,0,0) -  ( (new Date()).setHours(0,0,0,0))  > 86400000) return false;
    return true;
}

export const isPossibleCheckinDone =(arrival, departure)=>{
    return  (new Date(departure).setHours(0,0,0,0))>=((new Date()).setHours(0,0,0,0)) &&
            (new Date(arrival).setHours(0,0,0,0))-((new Date()).setHours(0,0,0,0))<= 86400000 ;
}

export const checkIsCheckinDone_callFetchBooking = async(stay, profile)=>{
    console.log("inside checkIsCheckinDone_callFetchBooking", stay)
    let isCheckInDone= false;
    let roomNo;
    let lastName;

    try{
        let formData= new FormData();
        formData.append("confirmationNumber",stay.pms_confirmation_number || "")
        formData.append("lastName",profile.last_name)
        formData.append("sessionToken",localStorage.getItem('GuestJourneySessionToken')) 
        formData.append("actionKey","bookingDataEnquiry")
        formData.append("legNumber","")
        formData.append("checkinDate",stay.arrival) //2024-11-26
        formData.append("checkInType","precheckin") 
        formData.append("loyaltyRewardId",profile.member_id) 
        await clientConfigApi.post(
            "/mobileCheckIn/guestBooking",formData)
            .then((response) => {       
                 
             })
            .catch((error)=>{
                if(error.response.status == 400){
                    if(error.response.data && error.response.data.header && error.response.data.header.status && error.response.data.header.status.guestCheckedIn && error.response.data.header.status.roomNumber && error.response.data.header.status.loyaltyRewardIdFlag)
                      isCheckInDone= Boolean(error.response.data.header.status.guestCheckedIn);
                      roomNo= error.response.data.header.status.roomNumber;
                      lastName= error.response.data.header.status.lastName;
                    }
            })

        }catch(err){
            console.log(err, JSON.stringify(err), "error")
        }
            
    

    return {isCheckInDone,roomNo, lastName};
}


// First filter data -> upcoming stays
    // if( currently not logined and not at master connector) -> Check if any stay  (  same locaiton +  today is btw arrival and departure ) -> call GuestBooking to know if checkin done-> if done, do auto login
    // else 
    // show upcommig stay with precheckin button only if shouldStayShowCheckInButton() is true
export const userAutoLoginUsingTheKnow = async (props, launchLoginUrlInIAB) => {
    console.log("inside userAutoLoginUsingTheKnow")

    if(launchLoginUrlInIAB ) handleCendynLoginCompleted(props);
    
    const base_url = Axios.create({ baseURL: `${CMSPath_Master}/Connector/rest` })

    const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('GuestJourneyMasterConnectorSessionToken')}` }
    };
  
    

    let res = await base_url.get(`/multiHotelApp/hotels`, config)
    
    let locationData= res.data.payload;

    const memberId = props.externalSignIn.memberId;
    let stayPayload;
  
    await getVredStayData(memberId)
    .then((res)=>{
        console.log("getVredStayData response is ", res)
         if(!(res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS" )){
            throw {response:res};
         }
  
         if(!(res.data.payload)){
            throw {response:res};
         } 
         stayPayload= res.data.payload;
         stayPayload.stay= res.data.payload.stay && res.data.payload.stay.sort((a,b)=> new Date(a.arrival).getTime() - new Date(b.arrival).getTime() )

         stayPayload.stay =  stayPayload.stay.filter(stay=> stay && stay.reservation_status_description && (stay.reservation_status_description == stayReservationPossibleStatus.CHECKED_IN ) );
         
         let theKnowUserInfo = JSON.parse(localStorage.getItem("theKnowUserInfo")) || {};
  
         localStorage.setItem("theKnowUserInfo", JSON.stringify({ ...theKnowUserInfo, lastName: stayPayload.profile && stayPayload.profile.last_name ,  firstName: stayPayload.profile && stayPayload.profile.first_name}))             
  
    })
    .catch(({response={}})=>{
        console.log("catch in stay api", response)
     })
  
      const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
      const master_hotel_code = process.env.REACT_APP_CLIENT_CONFIG.replace("GJ_", "").toUpperCase();
  
      if(!isUserLoggedin() && master_hotel_code!=current_hotel_code ) {
        console.log('current_hotel_code', current_hotel_code )
          let stay = stayPayload.stay.find((stay)=>{

              const hotelData= mapPmsPropertyCodeToHotelData(stay.pms_property_code, locationData.data);
              return (hotelData.hotelPropertyKey==current_hotel_code);
          })
  
          console.log("stay",stay)
  
          if( stay){
             const {isCheckInDone, roomNo, lastName}= await checkIsCheckinDone_callFetchBooking(stay, stayPayload.profile);
            
              if(isCheckInDone){
                  const loginAuthTokenData = {
                      // confirmationNumber:  stay.pms_confirmation_number,
                      lastName: lastName,
                      roomNumber: roomNo,
                      disableOtpFlow: true
                  }
                  
                  props.setShowAutoLoginPopup(true, loginAuthTokenData);
                  props.setGoHome(true);

                  return; 
              }else{
                  console.log("GuestBooking api failed or precheckin not done yet")
              }
          }else{
                  console.log("no such stay so that can be  ( upcoming + same locaiton + in a day is there ) ")
          }
      }
  
      
  }
  

const handleCendynLoginCompleted = async (props) =>{
          console.log("handleCendynLoginCompleted, started")
  
        let onSsoSuccessUrl;
            await getTheKnowLoginUrl()
                      .then((res) => {
                          console.log("getTheKnowLoginUrl response is ", res)
                          if (!(res && res.header && res.header.status && res.header.status.code == "SUCCESS")) {
                              throw { error: res };
                          }
          
                         onSsoSuccessUrl= res.payload.onSsoSuccessUrl;
                      })
                      .catch((err) => {
                          console.log("in catch of getTheKnowLoginUrl api call , error:", err)
                      })
                     

          inAppBrowser(onSsoSuccessUrl || "https://virginhotels.com/login",props, true, {dontSetCurrentWidget: true}, true)
  
      }

  export const stayReservationPossibleStatus = {
    CHECKED_IN:"Checked In",
    RESERVED: "Reserved",
    NO_SHOW : "No Show",
    CHECKED_OUT: "Checked Out",
    CANCELLED : "Cancelled"
  }